import { constant } from "common/constant";
import * as yup from "yup";

export const ApplicationSchema = yup.object({
  job: yup.string().required(constant.requiredJob),
  name: yup.string().required(constant.requiredName),
  email: yup.string().email(constant.invalidEmail).nullable(),
  phone: yup.string().required(constant.requiredPhone),
  location: yup.string().required(constant.requiredLocation),
  totalExperience: yup.string().nullable(),
  currentLocation: yup.string().nullable(),
  noticePeriod: yup.string().nullable(),
  status: yup.string().nullable(),
  applicationSource: yup.string().nullable(),
  title: yup.string().nullable(),
});
